var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedblueSpiral(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.dev/svgjs",
    viewBox: "0 0 800 800",
    opacity: 1,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "gggyrate-grad"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "hsl(240, 78%, 52%)",
    stopOpacity: 1,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "hsl(0, 86%, 38%)",
    stopOpacity: 1,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 9,
    stroke: "url(#gggyrate-grad)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "400,202 136,598 664,598",
    transform: "rotate(104, 400, 400)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400,214.375 152.5,585.625 647.5,585.625",
    transform: "rotate(97.5, 400, 400)",
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400,226.75 169,573.25 631,573.25",
    transform: "rotate(91, 400, 400)",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400,239.125 185.5,560.875 614.5,560.875",
    transform: "rotate(84.5, 400, 400)",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400,251.5 202,548.5 598,548.5",
    transform: "rotate(78, 400, 400)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400,263.875 218.5,536.125 581.5,536.125",
    transform: "rotate(71.5, 400, 400)",
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400,276.25 235,523.75 565,523.75",
    transform: "rotate(65, 400, 400)",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400,288.625 251.5,511.375 548.5,511.375",
    transform: "rotate(58.5, 400, 400)",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400,301 268,499 532,499",
    transform: "rotate(52, 400, 400)",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400,313.375 284.5,486.625 515.5,486.625",
    transform: "rotate(45.5, 400, 400)",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400,325.75 301,474.25 499,474.25",
    transform: "rotate(39, 400, 400)",
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400,338.125 317.5,461.875 482.5,461.875",
    transform: "rotate(32.5, 400, 400)",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400,350.5 334,449.5 466,449.5",
    transform: "rotate(26, 400, 400)",
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400,362.875 350.5,437.125 449.5,437.125",
    transform: "rotate(19.5, 400, 400)",
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400,375.25 367,424.75 433,424.75",
    transform: "rotate(13, 400, 400)",
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400,387.625 383.5,412.375 416.5,412.375",
    transform: "rotate(6.5, 400, 400)",
    opacity: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedblueSpiral);
export default __webpack_public_path__ + "static/media/redblue_spiral.45cd128152ae8380fed8736f477ba2df.svg";
export { ForwardRef as ReactComponent };